import { useQuery } from "@tanstack/react-query";
import { getHeyApiRequestOptions } from "apiClients/base/heyApiRequestOptions";
import { isAdminOrSuperAdmin } from "utility/helper";
import type { RevenueMarketFilter, RevenueTimeseriesResponse } from "../types";

async function fetchRevenueTimeseries(
  months: number,
  currency: RevenueMarketFilter,
): Promise<RevenueTimeseriesResponse> {
  const options = getHeyApiRequestOptions();
  const auth = options.auth?.();
  const params = new URLSearchParams({ months: String(months) });
  if (currency) {
    params.set("currency", currency);
  }

  const response = await fetch(
    `${options.baseUrl}/api/statistics/revenue/timeseries?${params}`,
    {
      headers: {
        Accept: "application/json",
        ...(auth ? { Authorization: auth } : {}),
      },
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to load revenue timeseries (${response.status})`);
  }

  return (await response.json()) as RevenueTimeseriesResponse;
}

export function useRevenueTimeseriesQuery(
  months = 12,
  currency: RevenueMarketFilter = null,
) {
  return useQuery({
    queryKey: ["dashboard-revenue-timeseries", months, currency ?? "all"],
    queryFn: () => fetchRevenueTimeseries(months, currency),
    enabled: isAdminOrSuperAdmin(),
  });
}
